<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProfitLoss'
}
</script>

<style scoped>
</style>
